/** @jsxImportSource @emotion/react */

import React from 'react'
import { Text, CategoryType } from '@components/atoms'
import { pink } from '@mui/material/colors'

interface PropsType {
	category?: CategoryType
	className?: string
	children?: string
	style?: React.CSSProperties
}

export const ErrorText = (props: PropsType) => {
	return (
		<Text
			category={props.category ?? 'p2'}
			className={props.className}
			css={{ color: pink['A400'] }}
			style={{ ...props.style }}
		>
			{props.children}
		</Text>
	)
}
